import React from 'react';

function About() {
  return (
    <section id="about" className="container py-5">
      <h3>¿Quiénes Somos?</h3>
      <p>
        Comercial AC 2025, C.A. es una empresa dedicada a la importación y comercialización de productos industriales, ferreteros, eléctricos y más, con enfoque en atender el mercado venezolano con calidad y compromiso.
      </p>
    </section>
  );
}

export default About;
